/**
 * ReBirth Reborn - Point d'entrée
 * Clone web moderne de ReBirth RB-338
 */

import { App } from './app.js';

// Initialisation au chargement du DOM
document.addEventListener('DOMContentLoaded', () => {
    const app = new App();
    app.init();

    console.log('🎹 ReBirth Reborn chargé !');
    console.log('Cliquez sur START pour commencer');
});
